import React from "react";
import ReactDOM from "react-dom/client";
import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "assets/css/app-consistency.css";

import "react-toastify/dist/ReactToastify.css";
import App from "../src/App.js";
import './utils/axiosConfig';
import { forceLogout } from './utils/logout';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient();

// Global fetch interceptor to detect invalid token across fetch-based clients
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  try {
    if (response && response.status === 401) {
      forceLogout('Invalid token. Please login again.');
      return response;
    }
    const cloned = response.clone();
    // Attempt to parse JSON safely
    let data = null;
    try {
      data = await cloned.json();
    } catch (e) {
      // non-JSON response, ignore
    }
    const message = data?.message || data?.error;
    if (typeof message === 'string' && message.toLowerCase().includes('invalid token')) {
      forceLogout('Invalid token. Please login again.');
    }
  } catch (e) {
    // ignore any parsing errors
  }
  return response;
};

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);